import { PaletteColor, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '100%',
    height: '95%',
    overflowY: 'auto',
    margin: '1rem 0',
  },

  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& h6': {
      margin: 0,
      padding: 0,
      font: 'Sora',
      fontSize: '1.25rem',
      lineHeigth: '2rem',
      fontWeight: '600',
    },
  },

  closeBtn: {
    cursor: 'pointer',
    transition: 'all 300ms ease-in-out',

    '&:hover': {
      color: (theme.palette.anger as PaletteColor).main,
    },
  },
}))

export { useStyles }
